import { changeContext, Auth } from '@core/auth';
import { isPublic } from '@core/router/utils';

const urlGuard = async (to, from, next) => {
    if (isPublic(to)) {
        next();
    } else {
        const auth = Auth();

        if (auth.organisation && !auth.has_valid_hostname) {
            changeContext(auth.organisation, auth.account);
            next();
        } else {
            next();
        }
    }
};

export default urlGuard;
